import * as PIXI from 'pixi.js';
import { ObjectPool } from '~/Tools';
import PortalEffect from './PortalEffect';
import ApplicationStore from '~/flux/stores/ApplicationStore';

let _cloudPool;
ApplicationStore.once(ApplicationStore.ASSETS_LOADED, () => {
  _cloudPool = new ObjectPool(
    () => {
      const sprite = new PIXI.Sprite(PIXI.utils.TextureCache['effects/cloud.png']);
      sprite.anchor.x = sprite.anchor.y = 0.5;
      return sprite;
    },
    (cloud) => {
      gsap.killTweensOf(cloud);
      cloud.parent?.removeChild(cloud);
      cloud.scale.x = cloud.scale.y = 1;
    },
    40
  );
});

export default {
  makePortalEffect: (victimSprite) => {
    var portal = new PortalEffect(2200);
    portal.scale.y = portal.scale.x = 0.7; // 3.5;
    victimSprite.tileImg.addChild(portal);

    var tween = TweenMax.from(portal.scale, 3.5, {
      x: 0,
      y: 0,
      ease: Elastic.easeOut,
    });

    TweenMax.delayedCall(
      1.85,
      (portalImg) => {
        tween = TweenMax.to(portalImg.scale, 0.25, {
          x: 0,
          y: 0,
          ease: Expo.easeIn,
          onComplete: () => {
            if (portalImg.parent) portalImg.parent.removeChild(portalImg);
          },
        });
      },
      [portal]
    );
  },

  makeCloudPuff: (homeSprite, colorTag = 0xffffff) => {
    const duration = 1 + Math.random() * 1.2;
    const image = _cloudPool.get();
    image.tint = colorTag;
    image.alpha = 0;

    image.x = homeSprite.x;
    image.y = homeSprite.y;

    if (homeSprite?.parent) {
      homeSprite.parent.addChild(image);
    } else {
      _cloudPool.put(image);
      return;
    }

    const _timeline = new TimelineMax({
      onComplete: _cloudPool.put,
      onCompleteParams: [image],
    });

    const fadeInTime = 0.05 + Math.random() * 0.15;
    _timeline.add(
      TweenMax.to(image, fadeInTime, {
        alpha: 0.3,
        onComplete: (image, remainingDuration) => {
          _timeline.add(
            TweenMax.to(image, remainingDuration, {
              alpha: 0,
              ease: Expo.easeIn,
            }),
            _timeline._time
          );
        },
        onCompleteParams: [image, duration - fadeInTime],
      }),
      _timeline._time
    );

    const xDest = homeSprite.x - 14 + Math.random() * 28;
    const yDest = homeSprite.y - 10 - Math.random() * 49;

    const rotation_tween = TweenMax.to(image, duration, {
      x: xDest,
      y: yDest,
      rotation: (-50 + Math.random() * 100) * (Math.PI / 180),
      ease: Linear.easeNone,
      onUpdate: (img) => {
        !img?.parent && rotation_tween.kill();
      },
      onUpdateParams: [image],
    });
    _timeline.add(rotation_tween, _timeline._time);

    _timeline.add(TweenMax.from(image.scale, 0.5, { x: 0, y: 0 }), _timeline._time);
  },
};
